import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Comment } from 'ng2-app/modules/comment/models/comment/comment.model';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { take } from 'rxjs/operators';
import { Select } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { Observable } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
    selector: 'borrower-activity-comments',
    templateUrl: './borrower-activity-comments.component.html',
    styleUrls: ['./borrower-activity-comments.component.scss'],
    standalone: false
})
export class BorrowerActivityCommentsComponent implements OnInit {
    @Input() activity: Activity;
    @Input() comments: Comment[];
    @Output() cancelAdd: EventEmitter<any> = new EventEmitter();
    @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

    user: LenderUser;

    constructor() { }

    ngOnInit() {
        this.lenderUser$.pipe(take(1)).subscribe(user => {
            this.user = user;
        });
    }

    onCancelAdd() {
        if (!this.comments.length) {
            this.cancelAdd.next(true);
        }
    }
}
